const SET_SEARCH = 'SET_SEARCH'
const SET_ORDER_BY = 'SET_ORDER_BY'
const SET_TYPE = 'SET_TYPE'
const SET_STATUS = 'SET_STATUS'

export { SET_SEARCH, SET_ORDER_BY, SET_TYPE, SET_STATUS }
